import { Box, Button, Divider, Paper, Typography } from "@mui/material";
import {
  fallback,
  formatCategory,
  formatCurrency,
  getInitials,
} from "../utils/formatters";
import { ReferralProgram } from "../types/view.referral";

interface Props {
  data: ReferralProgram;
}

const statCardSx = {
  flex: 1,
  minWidth: 120,
  backgroundColor: "#F3F5F8",
  borderRadius: "14px",
  px: 2,
  py: 1.5,
  textAlign: "center",
};

export default function ReferralProfileCard({ data }: Props) {
  const fullName =
    `${fallback(data.name, "")} ${fallback(data.surname, "")}`.trim();

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "24px",
        p: 3,
        backgroundColor: "#fff",
        height: "100%",
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            backgroundColor: "#A98776",
            color: "#fff",
            display: "grid",
            placeItems: "center",
            fontWeight: 700,
            fontSize: "1.7rem",
            mb: 2,
          }}
        >
          {getInitials(data.name, data.surname)}
        </Box>

        <Typography
          sx={{ fontSize: "1rem", fontWeight: 700, color: "#161616" }}
        >
          {fullName || "N/A"}
        </Typography>

        <Box
          sx={{
            mt: 1,
            px: 1.5,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: "#E7F1FF",
            color: "#4490FF",
            fontSize: "0.8rem",
          }}
        >
          {formatCategory(data.organisation_category)}
        </Box>

        <Typography sx={{ mt: 2, color: "#2B2B2B" }}>
          {fallback(data.consultant_name)}
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 1.5,
        }}
      >
        <Box sx={statCardSx}>
          <Typography sx={{ fontSize: "1rem", fontWeight: 700 }}>
            N/A
          </Typography>
          <Typography sx={{ fontSize: "0.7rem", color: "#7C8798" }}>
            Total Referrals
          </Typography>
        </Box>

        <Box sx={statCardSx}>
          <Typography sx={{ fontSize: "1rem", fontWeight: 700 }}>
            N/A
          </Typography>
          <Typography sx={{ fontSize: "0.7rem", color: "#7C8798" }}>
            Conversion
          </Typography>
        </Box>

        <Box sx={statCardSx}>
          <Typography sx={{ fontSize: "1rem", fontWeight: 700 }}>
            {formatCurrency(data.lifetime_earned)}
          </Typography>
          <Typography sx={{ fontSize: "0.7rem", color: "#7C8798" }}>
            Lifetime Earned
          </Typography>
        </Box>

        <Box sx={statCardSx}>
          <Typography sx={{ fontSize: "1rem", fontWeight: 700 }}>
            {formatCurrency(data.pending_balance)}
          </Typography>
          <Typography sx={{ fontSize: "0.7rem", color: "#7C8798" }}>
            Pending
          </Typography>
        </Box>
      </Box>

      <Button
        fullWidth
        sx={{
          mt: 3,
          py: 1.5,
          borderRadius: "12px",
          backgroundColor: "#7B5648",
          color: "#fff",
          textTransform: "none",
          fontWeight: 500,
          "&:hover": {
            backgroundColor: "#6A493D",
          },
        }}
      >
        Message
      </Button>
    </Paper>
  );
}
